// src/config.js
export const BMC_LINK = 'https://www.buymeacoffee.com/pixelwizardapp';
